import { render, staticRenderFns } from "./TagsArea.vue?vue&type=template&id=3f91e962&"
import script from "./TagsArea.vue?vue&type=script&lang=js&"
export * from "./TagsArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports